import { apiClient } from "@/core/api/ApiClient";
import { ContractDto, EntityType } from "@/core/api/generated/v1";

import BaseEntitiesDeleteModal, {
  BaseEntitiesDeleteModalInheritableProps,
} from "../components/BaseEntitiesDeleteModal";

export interface OwnProps {
  entities: ContractDto[];
}

type Props = OwnProps & BaseEntitiesDeleteModalInheritableProps;

export default function ContractsDeleteModal({ entities, ...otherProps }: Props) {
  return (
    <BaseEntitiesDeleteModal
      cascadeActionDisplay={true}
      entityType={EntityType.Contract}
      entities={entities}
      deleteFunc={async (params) => {
        await apiClient.contractsApi.apiV1ContractsBulkDeleteDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          contractBulkDeleteDto: {
            ids: params.entityIds,
            relatedEntitiesTypes: params.relatedEntitiesTypes,
          },
        });
      }}
      {...otherProps}
    />
  );
}
